import { Field } from '../../../../environments/field';
import { environment } from '../../../../environments/environment';

let token = sessionStorage.getItem('token');

export let fields: Array<Field> = [
  {
    type: 'checkbox',
    name: 'activo',
    label: 'Activo',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-12',
  },
  {
    type: 'text',
    name: 'nombre',
    label: 'Nombre',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'apellido',
    label: 'Apellido',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'telefono',
    label: 'Telefono',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'codigo_postal',
    label: 'Codigo postal',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'calle',
    label: 'Calle',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'no_exterior',
    label: 'Numero exterior',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'no_interior',
    label: 'Numero interior',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-4',
  },
  {
    type: 'text',
    name: 'colonia',
    label: 'Colonia',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'ciudad',
    label: 'Ciudad',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'estado',
    label: 'Estado',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'label',
    name: 'Datos de usuario',
    label: 'Datos de usuario',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-12',
  },
  {
    type: 'text',
    name: 'username',
    label: 'Nombre de usuario',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'email',
    label: 'Correo Electrónico',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'password',
    name: 'password',
    label: 'Contraseña',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-6',
  },
  {
    type: 'password',
    name: 'repet_password',
    label: 'Repetir contraseña',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-6',
  },

  ];
